import "./App.scss";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./components/header/header.comp";
import Home from "./pages/home/home.page";
import Error from "./pages/error/error.page";
import Skill from "./pages/skill/skill.page";
import Experience from "./pages/experience/experience.page";
import Project from "./pages/project/project.page";
import Contact from "./pages/contact/contact.page";
import Review from "./pages/review/review.page";
import Footer from "./components/footer/footer.comp";
import { LanguageProvider } from "./contexts/language/language.context";
import { useResponsive, ScreenType } from "./hooks/responsive.hook";

function App() {
  document.title = "Portfolio | Brillant";

  /* RESPONSIVE */
  const { currentScreen }: { currentScreen: ScreenType } = useResponsive();
  return (
    <div
      className={`app-container ${currentScreen.size}-screen-size ${currentScreen.orientation}-screen-orientation`}
    >
      <Router>
        <LanguageProvider>
          <Header></Header>

          <section className="router-outlet">
            <Routes>
              <Route path="/" element={<Navigate to={"/about-me"} />} />
              <Route path="/about-me" element={<Home />} />
              <Route path="/skills" element={<Skill />} />
              <Route path="/experiences" element={<Experience />} />
              <Route path="/projects" element={<Project />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/review" element={<Review />} />
              <Route path="*" element={<Error />} />
            </Routes>

            <Footer></Footer>
          </section>
        </LanguageProvider>
      </Router>
    </div>
  );
}

export default App;
